export { default } from './RubberPurchaseCreateAndUpdateModal'
